// extracted by mini-css-extract-plugin
export default {"root":"Label_root__uWPJK","primary":"Label_primary__BQFzb","secondary":"Label_secondary__9fGy-","medium":"Label_medium__gT+I9","large":"Label_large__N68uI"};